import isValidZipCode from './isValidZipCode';
import { DefaultLocation } from '../constants';
import { CookieClient, LocationData } from '../types';

export default function formatLocationOnError(
  cookies: CookieClient
): Pick<LocationData, 'city' | 'state' | 'zip' | 'ipAddress'> {
  const {
    CVCurrentCity: city,
    CVCurrentState: state,
    CVCurrentZip: zip
  } = Object.fromEntries(cookies.getAll() ?? []);

  return city && state && isValidZipCode(zip)
    ? { city, state, zip }
    : DefaultLocation;
}
